export default __webpack_public_path__ + "static/media/Lojas_on_light_blue.b890e0cf.svg";